import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgOtpInputModule } from "ng-otp-input";

@Component({
  selector: "megastore-otp",
  standalone: true,
  imports: [CommonModule, NgOtpInputModule],
  templateUrl: "./otp.component.html",
  styles: [
    `
      :host ::ng-deep .ng-otp-input-wrapper {
        direction: ltr !important;
      }
      :host ::ng-deep .otp-input {
        direction: ltr !important;
      }
    `,
  ],
})
export class OtpComponent {
  @Output() otp = new EventEmitter();
  code = "";
  @Input() length: number = 4;

  onOtpChange(event: string): void {
    this.code = event;
    this.otp.emit(this.code);
  }
}
